import React from "react";
import { rupees } from "../../../shared/components/tableColumns.jsx";

const TYPE_LABELS = { vendor: "🏭 Vendor", both: "🔄 Both", customer: "🛒 Customer" };

const actionButton = (title, icon, onClick, extraClass = "") => (
  <button
    type="button"
    className={`btn-icon table-action ${extraClass}`}
    title={title}
    aria-label={title}
    onClick={(e) => {
      e.stopPropagation();
      onClick();
    }}
  >
    {icon}
  </button>
);

/**
 * Desktop table columns for the Parties list. Row click opens the ledger;
 * the actions column mirrors the card buttons (settle, invoices, rates, addresses, edit, delete).
 */
export function customerColumns({ onSettle, onInvoices, onRates, onAddresses, onEdit, onDelete }) {
  return [
    { key: "name", label: "Name", render: (c) => <strong>{c.name}</strong> },
    {
      key: "partyType",
      label: "Type",
      width: 120,
      sortValue: (c) => c.partyType || "customer",
      render: (c) => TYPE_LABELS[c.partyType] || TYPE_LABELS.customer
    },
    { key: "mobile", label: "Phone", width: 130, render: (c) => c.mobile || <span className="text-dim">—</span> },
    {
      key: "city",
      label: "City",
      width: 170,
      optional: true,
      sortValue: (c) => c.city || "",
      render: (c) => [c.city, c.state].filter(Boolean).join(", ") || <span className="text-dim">—</span>
    },
    { key: "gstin", label: "GSTIN", width: 170, render: (c) => c.gstin || <span className="text-dim">Unregistered</span> },
    {
      key: "companyDue",
      label: "Balance",
      width: 130,
      align: "right",
      className: "amount",
      sortValue: (c) => Number(c.companyDue ?? c.openingBalance ?? 0),
      render: (c) => {
        const balance = Number(c.companyDue ?? c.openingBalance ?? 0);
        if (!(balance > 0)) return <span className="text-dim">₹0</span>;
        return <span className={c.partyType === "vendor" ? "text-danger" : "text-warning"}>{rupees(balance)}</span>;
      }
    },
    {
      key: "actions",
      label: "Actions",
      width: 230,
      noSort: true,
      align: "right",
      render: (c) => (
        <span className="table-actions">
          {Number(c.companyDue ?? c.openingBalance ?? 0) > 0 && actionButton("Settle balance", "💰", () => onSettle(c))}
          {actionButton("Invoices", "🧾", () => onInvoices(c))}
          {actionButton("Custom rates", "🏷️", () => onRates(c))}
          {actionButton("Addresses", "📍", () => onAddresses(c))}
          {actionButton("Edit", "✏️", () => onEdit(c))}
          {actionButton("Delete", "🗑️", () => onDelete(c), "danger")}
        </span>
      )
    }
  ];
}
